// illCurrency: rows that scroll sideways ([data-ill-cue]) get a round arrow at the edge while there is more to see.
// The attribute value is the element the arrow centres on (for example the tile photo, not the label under it).
(() => {
  if (window.illRowCue) {
    window.illRowCue();
    return;
  }
  const style = document.createElement('style');
  style.textContent = [
    '.ill-cue{--font-button-size:14px;--font-button-size-mobile:14px;position:absolute;z-index:3;top:0;width:36px;height:36px;margin:0;padding:0;border:1px solid #e3e3e3;border-radius:50%;background:#fff;color:#111;box-shadow:0 2px 8px rgba(0,0,0,.16);display:flex;align-items:center;justify-content:center;cursor:pointer;transition:opacity .15s ease}',
    '.ill-cue::before{content:"";position:absolute;inset:-4px}',
    '.ill-cue[hidden]{display:none}',
    '.ill-cue--next{right:4px}',
    '.ill-cue--prev{left:4px}',
    '.ill-cue:focus-visible{outline:2px solid #f6a429;outline-offset:2px}',
    '@media (prefers-reduced-motion: reduce){.ill-cue{transition:none}}'
  ].join('');
  document.head.appendChild(style);

  const icon = (dir) => `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${dir === 'next' ? 'M9 5l7 7-7 7' : 'M15 5l-7 7 7 7'}"/></svg>`;

  const setup = (list) => {
    if (list.dataset.illCueOn) return;
    list.dataset.illCueOn = '1';
    const host = list.parentElement;
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    const make = (dir) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `ill-cue ill-cue--${dir}`;
      b.setAttribute('aria-label', dir === 'next' ? 'Show more' : 'Show previous');
      b.innerHTML = icon(dir);
      b.hidden = true;
      b.addEventListener('click', () => {
        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        list.scrollBy({ left: (dir === 'next' ? 1 : -1) * Math.round(list.clientWidth * 0.8), behavior: reduce ? 'auto' : 'smooth' });
      });
      host.appendChild(b);
      return b;
    };
    const next = make('next');
    const prev = make('prev');
    let frame = 0;
    const place = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const over = list.scrollWidth > list.clientWidth + 4;
        next.hidden = !over || list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
        prev.hidden = !over || list.scrollLeft <= 4;
        if (!over) return;
        let ref = list;
        try { ref = (list.dataset.illCue && list.querySelector(list.dataset.illCue)) || list; } catch (e) { ref = list; }
        const h = host.getBoundingClientRect();
        const r = ref.getBoundingClientRect();
        const top = `${Math.round(r.top - h.top + r.height / 2 - 18)}px`;
        next.style.top = top;
        prev.style.top = top;
      });
    };
    list.addEventListener('scroll', place, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(place).observe(list);
    else window.addEventListener('resize', place);
    list.querySelectorAll('img').forEach((img) => { if (!img.complete) img.addEventListener('load', place, { once: true }); });
    place();
  };

  const scan = () => document.querySelectorAll('[data-ill-cue]').forEach(setup);
  window.illRowCue = scan;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
